
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export * from './model/useUserInfoStore'
export * from './model/useRouteStore'


const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export default pinia
